<template>
  <div>
    <Title :pages="[{ icon: 'bolt', page: 'WEBHOOKS' }]"></Title>
    <v-container fluid>
      <v-card class="mb-4">
        <div class="row mb-2 ps-3 pe-3 mt-0 mb-2">
          <div class="col-md-12">
            <div class="col-md-12" style="background: white">
              <p class="text-h6 mt-2 mb-0"><font-awesome-icon icon="filter" class="pr-2" />Filtros</p>
              <v-divider class="mt-0"></v-divider>
              <div class="row pt-2">
                <div class="col-md-3">
                  <v-text-field v-model="filters.creation_date_from" density="comfortable" type="date" label="Desde"></v-text-field>
                </div>
                <div class="col-md-3">
                  <v-text-field v-model="filters.creation_date_to" density="comfortable" type="date" label="Hasta"></v-text-field>
                </div>
                <div class="col-md-3">
                  <v-combobox v-model="filters.client" density="comfortable" item-title="name" item-value="id" :items="clients" label="Cliente" autocomplete="off" clearable :loading="loading_clients"></v-combobox>
                </div>
                <div class="col-md-3">
                  <v-combobox v-model="filters.event_type" density="comfortable" item-title="name" item-value="id" :items="event_types" label="Tipo de Evento" autocomplete="off" clearable></v-combobox>
                </div>
                <div class="col-md-3">
                  <v-combobox v-model="filters.state" density="comfortable" item-title="name" item-value="id" :items="service.STATE_OPTIONS" label="Estado" autocomplete="off" clearable></v-combobox>
                </div>
                <div class="col-md-3">
                  <v-text-field v-model="filters.associated_code" density="comfortable" label="Código Asociado" autocomplete="off" clearable hint="Filtra sobre los resultados cargados" persistent-hint></v-text-field>
                </div>
                <div class="col-md-6 pt-3 pb-3" style="display: flex; justify-content: end; align-items: start">
                  <v-btn color="info" @click="filter" prepend-icon="mdi-magnify">Buscar</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>

      <v-card v-if="list_access">
        <v-card-title>
          <v-row align="center" class="mt-1">
            <v-col cols="auto"><span>Webhooks</span></v-col>
            <v-spacer></v-spacer>
            <v-col>
              <v-text-field v-model="search" append-inner-icon="mdi-magnify" single-line hide-details label="Buscar" density="compact"></v-text-field>
            </v-col>
          </v-row>
        </v-card-title>

        <v-data-table
          v-model:page="current_page"
          v-model:items-per-page="items_per_page"
          :items-per-page-options="items_per_page_options"
          :headers="headers"
          :items="filteredList"
          :search="search"
          :loading="loading"
          loading-text="Cargando..."
        >
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ item.id }}</td>
              <td>{{ item.client_name || "-" }}</td>
              <td>{{ item.creation_date || "-" }}</td>
              <td>{{ service.getEventTypeName(item.event_type) }}</td>
              <td class="text-center">
                <span class="status-badge" :class="service.getState(item) === service.STATE_FAILED ? 'status-unresolved' : ''">
                  {{ item.attempts }}
                </span>
              </td>
              <td>{{ item.last_attempts_date || "-" }}</td>
              <td>{{ item.delivered_date || "-" }}</td>
              <td class="text-center">
                <span class="webhook-state" :class="'webhook-state--' + service.getState(item)">
                  {{ service.getStateName(item) }}
                </span>
              </td>
              <td style="max-width: 220px">
                <div class="text-truncate text-caption" style="max-width: 220px">{{ item.last_response_log || "-" }}</div>
                <a v-if="item.last_response_log" class="text-caption text-blue" style="cursor: pointer" @click="openResponse(item)">Ver completa</a>
              </td>
              <td>{{ item.associated_code || "-" }}</td>
              <td class="text-center">
                <v-btn size="x-small" variant="tonal" color="blue" @click="openPayload(item)">Ver</v-btn>
              </td>
              <td class="text-center" style="min-width: 90px">
                <template v-if="update_access && !item.delivered_date && !item.not_subscribed">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ props }">
                      <v-icon v-bind="props" small color="warning" v-on:click="openResendDialog(item)" size="small">mdi-refresh</v-icon>
                    </template>
                    <span>Reenviar webhook</span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="item.attempts >= service.MAX_ATTEMPTS">
                    <template v-slot:activator="{ props }">
                      <v-icon v-bind="props" small color="blue" class="ml-2" v-on:click="openResetDialog(item)" size="small">mdi-restore</v-icon>
                    </template>
                    <span>Resetear intentos</span>
                  </v-tooltip>
                </template>
                <span v-else>-</span>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>

      <div class="text-right mt-2">
        <small class="text-grey">{{ paginationText }}</small>
      </div>
    </v-container>

    <!-- Modal Payload -->
    <v-dialog v-model="dialog_payload" max-width="800" scrollable>
      <v-card>
        <v-card-title class="headline d-flex align-center">
          <span>Payload del webhook #{{ selected_item ? selected_item.id : "" }}</span>
          <v-spacer></v-spacer>
          <v-btn size="small" variant="text" prepend-icon="mdi-content-copy" @click="copyPayload">Copiar</v-btn>
        </v-card-title>
        <v-card-text>
          <pre class="payload-json">{{ prettyPayload }}</pre>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="dialog_payload = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal Última respuesta -->
    <v-dialog v-model="dialog_response" max-width="700" scrollable>
      <v-card>
        <v-card-title class="headline">Última respuesta del webhook #{{ selected_item ? selected_item.id : "" }}</v-card-title>
        <v-card-text>
          <pre class="payload-json">{{ selected_item ? selected_item.last_response_log : "" }}</pre>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="dialog_response = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal Confirmación Reenviar -->
    <DialogYesNo
      :open="dialog_resend"
      title="Reenviar webhook"
      :message="'¿Desea reintentar el envío del webhook #' + (selected_item ? selected_item.id : '') + '?'"
      :loading="loadingSubmit"
      @accept="confirmResend"
      @cancel="dialog_resend = false"
    />

    <!-- Modal Confirmación Resetear intentos -->
    <DialogYesNo
      :open="dialog_reset"
      title="Resetear intentos"
      :message="'¿Desea volver a 0 los intentos del webhook #' + (selected_item ? selected_item.id : '') + '? Se reenviará automáticamente en el próximo ciclo.'"
      :loading="loadingSubmit"
      @accept="confirmReset"
      @cancel="dialog_reset = false"
    />
  </div>
</template>

<script>
import { webhookService } from "@/libs/ws/webhookService";
import { clientService } from "@/libs/ws/clientService";
import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import DialogYesNo from "@/components/DialogYesNo.vue";

export default {
  components: { DialogYesNo },
  mixins: [GenericMixin, RolMixin],
  data() {
    return {
      service: webhookService,
      page_title: "Webhooks",
      clients: [],
      event_types: [],
      loading_clients: false,
      current_page: 1,
      items_per_page: 20,
      items_per_page_options: [
        { value: 10, title: "10" },
        { value: 20, title: "20" },
        { value: 50, title: "50" },
        { value: 100, title: "100" },
        { value: -1, title: "Todos" },
      ],
      dialog_payload: false,
      dialog_response: false,
      dialog_resend: false,
      dialog_reset: false,
      selected_item: null,
      headers: [
        { title: "ID", key: "id", sortable: true },
        { title: "Cliente", key: "client_name", sortable: true },
        { title: "Fecha Creación", key: "creation_date", sortable: true },
        { title: "Tipo de Evento", key: "event_type", sortable: true },
        { title: "Intentos", key: "attempts", sortable: true, align: "center" },
        { title: "Últ. intento", key: "last_attempts_date", sortable: true },
        { title: "Fecha de envío", key: "delivered_date", sortable: true },
        { title: "Estado", key: "state", sortable: false, align: "center" },
        { title: "Última respuesta", key: "last_response_log", sortable: false },
        { title: "Código Asociado", key: "associated_code", sortable: false },
        { title: "Payload", key: "payload", sortable: false, align: "center" },
        { title: "Acción", key: "actions", sortable: false, align: "center" },
      ],
      filters: {
        creation_date_from: new Date(new Date().toLocaleDateString("en-US", { timeZone: "America/Buenos_Aires" })).toISOString().slice(0, 10),
        creation_date_to: new Date(new Date().toLocaleDateString("en-US", { timeZone: "America/Buenos_Aires" })).toISOString().slice(0, 10),
        client: null,
        event_type: null,
        state: null,
        associated_code: null,
      },
    };
  },
  mounted() {
    this.filter();
    this.loadClients();
    this.loadEventTypes();
  },
  computed: {
    // Filtro por codigo asociado, aplicado en el frontend sobre los resultados ya cargados
    filteredList() {
      const code = (this.filters.associated_code || "").toString().trim().toLowerCase();
      if (!code) return this.list;
      return this.list.filter((item) => (item.associated_code || "").toString().toLowerCase().includes(code));
    },
    // Sobrescribe el texto del GenericMixin: la paginacion ahora es del lado del frontend
    paginationText() {
      const total = this.filteredList.length;
      if (total === 0) return "No hay resultados";
      if (this.items_per_page === -1) return `Mostrando ${total} de ${total} resultados`;
      const start = (this.current_page - 1) * this.items_per_page + 1;
      const end = Math.min(this.current_page * this.items_per_page, total);
      return `Mostrando ${start} a ${end} de ${total} resultados`;
    },
    prettyPayload() {
      if (!this.selected_item || !this.selected_item.payload) return "";
      try {
        return JSON.stringify(JSON.parse(this.selected_item.payload), null, 2);
      } catch (e) {
        return this.selected_item.payload;
      }
    },
  },
  watch: {
    // Al cambiar el filtro por codigo asociado o la busqueda, volvemos a la primera pagina
    "filters.associated_code"() {
      this.current_page = 1;
    },
    search() {
      this.current_page = 1;
    },
  },
  methods: {
    getFilterParams() {
      return {
        creation_date_from: this.filters.creation_date_from,
        creation_date_to: this.filters.creation_date_to,
        client: this.filters.client ? this.filters.client.id : null,
        event_type: this.filters.event_type ? this.filters.event_type.id : null,
        state: this.filters.state ? this.filters.state.id : null,
      };
    },
    filter() {
      this.current_page = 1;
      this.loadList();
    },
    // Sobrescribe GenericMixin.loadList: trae todos los resultados que matchean los filtros del
    // backend (sin limit/from) y la paginacion pasa a resolverse en la v-data-table (frontend).
    loadList() {
      this.loading = true;
      const param = Object.assign({ enable: true }, this.getFilterParams());
      this.service
        .filter(param)
        .then((response) => {
          this.list = response.result.list;
          this.total = response.result.total;
          this.current_page = 1;
        })
        .catch((e) => {
          console.log("webhookService.filter error", e);
          this.toast.error("Error al cargar los webhooks");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    loadClients() {
      this.loading_clients = true;
      clientService
        .filter({})
        .then((response) => {
          this.clients = response.result.list;
        })
        .catch((e) => {
          console.log("clientService.filter error", e);
        })
        .finally(() => {
          this.loading_clients = false;
        });
    },
    loadEventTypes() {
      webhookService.list_event_types().then((response) => {
        this.event_types = response.result;
      });
    },
    openPayload(item) {
      this.selected_item = item;
      this.dialog_payload = true;
    },
    openResponse(item) {
      this.selected_item = item;
      this.dialog_response = true;
    },
    openResendDialog(item) {
      this.selected_item = item;
      this.dialog_resend = true;
    },
    openResetDialog(item) {
      this.selected_item = item;
      this.dialog_reset = true;
    },
    copyPayload() {
      if (!navigator.clipboard) {
        this.toast.error("No se pudo copiar al portapapeles");
        return;
      }
      navigator.clipboard.writeText(this.prettyPayload).then(
        () => this.toast.success("Payload copiado"),
        () => this.toast.error("No se pudo copiar")
      );
    },
    async confirmResend() {
      if (!this.selected_item) return;
      this.loadingSubmit = true;
      try {
        const response = await webhookService.resend(this.selected_item.id);
        if (response.status) {
          this.toast.success(response.msg);
          this.dialog_resend = false;
          this.loadList();
        } else {
          this.toast.error(response.msg);
        }
      } catch (error) {
        this.toast.error("Error al reenviar el webhook");
        console.error(error);
      } finally {
        this.loadingSubmit = false;
      }
    },
    async confirmReset() {
      if (!this.selected_item) return;
      this.loadingSubmit = true;
      try {
        const response = await webhookService.reset(this.selected_item.id);
        if (response.status) {
          this.toast.success(response.msg);
          this.dialog_reset = false;
          this.loadList();
        } else {
          this.toast.error(response.msg);
        }
      } catch (error) {
        this.toast.error("Error al resetear el webhook");
        console.error(error);
      } finally {
        this.loadingSubmit = false;
      }
    },
  },
};
</script>

<style scoped>
.payload-json {
  background: #f5f5f5;
  border-radius: 4px;
  padding: 12px;
  font-size: 12px;
  white-space: pre-wrap;
  word-break: break-word;
  max-height: 60vh;
  overflow: auto;
}

.webhook-state {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  color: #fff;
}
.webhook-state--delivered {
  background-color: #4caf50;
}
.webhook-state--pending {
  background-color: #90a4ae;
}
.webhook-state--failed {
  background-color: #e53935;
}
.webhook-state--not_subscribed {
  background-color: #ffa726;
}
</style>
